<template>
  <div>
    <v-alert type="info" v-if="divivaAnoPassado">Estudante com dividas do ano passado!</v-alert>

    <!-- ===== INÍCIO DA TABELA ==== -->
    <div class="main_table_container">
      <table class="table-full">
        <thead class="bg-gray100">
          <tr>
            <th class="table_head">#</th>
            <th class="table_head">Emolumento</th>
            <th class="table_head">Referência</th>
            <th class="table_head">Ano</th>
            <th class="table_head">Quantidade</th>
            <th class="table_head">Preço Unitário</th>
            <th class="table_head">IVA</th>
            <th class="table_head">Desconto</th>
             <th class="table_head">Subtotal</th>
            <th class="table_head">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(emolumento, index) in desserts" :key="index">
            <td class="table_data">{{ ++index }}</td>
            <td class="table_data">
              <span class="color-table-data">{{ emolumento.emolumento }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.getMonthDescription(emolumento.fkMes)
              }}</span>
            </td>
            <td class="table_data">
              <span>{{ emolumento.anolectivo }}</span>
            </td>
            <td class="table_data">
              <span>{{ emolumento.qtd }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.IntegerToMoneyValueFatura(emolumento.preco)
              }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.IntegerToMoneyValueFatura(emolumento.iva)
              }}</span>
            </td>
            <td class="table_data">
              <input style="
                  background-color: #fff;
                  border: 1px solid #e2e8f0;
                  width: 100%;
                  padding: 2px;
                  text-align: center;
                " v-if="emolumento.isSelected" @change="moneyFormat(emolumento)"
                :disabled="!desserts[desserts.indexOf(emolumento)].isSelected"
                v-model="desserts[desserts.indexOf(emolumento)].desconto" />
              <span v-if="!emolumento.isSelected">{{
                isNaN(emolumento.desconto) || !emolumento.desconto
                  ? ""
                  : utilitarios.IntegerToMoneyValueFatura(emolumento.desconto)
              }}</span>
            </td>
            
            <td class="table_data">
              <span>{{
                utilitarios.IntegerToMoneyValueFatura(emolumento.subtotal)
              }}</span>
            </td>
            <td class="table_data">
              <span>
                <v-btn small fab color="#4b5747" v-if="emolumento.cobrar">
                  <input class="form-check-input" @change="uncheckFunction(emolumento)" type="checkbox"
                    v-model="desserts[desserts.indexOf(emolumento)].isSelected" id="flexCheckChecked" />
                </v-btn>
                <v-tooltip left v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab color="warning" style="color: white; margin-top: 5px" small>
                      <v-icon>info</v-icon>
                    </v-btn>
                  </template>
                  <span> Mês inseto de cobrança! </span>
                </v-tooltip>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- ===== FIM DA TABELA ==== -->

    <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
    <div class="totaisContainer">
      <div>
        <span class="align-totais">A cobrar:</span>
        <span class="text-bold totais-font-size">{{
          utilitarios.IntegerToMoneyValueFatura(totaisObject.total)
        }}</span>
      </div>
       
      <div>
        <span class="align-totais">Descontos:</span>
        <span v-if="!isNaN(totaisObject.desconto)" class="text-bold totais-font-size">
          {{ utilitarios.IntegerToMoneyValueFatura(totaisObject.desconto) }}
        </span>
      </div>
      <div>
        <span class="align-totais">Total a pagar:</span>
        <span v-if="!isNaN(totaisObject.totalGeral)" class="text-bold totais-font-size">
          {{ utilitarios.IntegerToMoneyValueFatura(totaisObject.totalGeral) }}
        </span>
      </div>
    </div>
    <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->

    <!--====== BOTÃO FINALIZAR PAGAMENTO =======-->
    <v-row style="padding-bottom: 15px">
      <div class="botoesAccaoContainer">
        <v-tooltip bottom v-if="isAtLeastOneEmolumentoSelected && !isError">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="continuarPagamento()" color="success">
              <v-icon>done</v-icon> Continuar
            </v-btn>
          </template>
          <span> Continuar o processo de pagamento</span>
        </v-tooltip>
      </div>
    </v-row>
    <!--====== FIM BOTÃO FINALIZAR PAGAMENTO =======-->
  </div>
</template>

<script>
import utilitarios from "../../../plugins/utilitarios";
import axios from "../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");

export default {
  data() {
    return {
      utilitarios: utilitarios,
      isError: false,
      divivaAnoPassado: false,
      desserts: [],
      dessertsPassados: [],
      trimestreSeleted: {
        id: 0,
        descricao: "Todos",
      },
      dataPagamentoSelected: null,
      emolumentos: [],
      bolseiro: null
    };
  },

  props: {
    estudante: Object,
    dataPagamento: undefined,
    trimestre: {
      type: Object,
      default: null,
    },
    anoLectivoEscolhido: []
  },

  watch: {
    dataPagamento: {
      immediate: true,
      handler(newVal) {
        this.dataPagamentoSelected = newVal;
      },
    },
    trimestre: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.trimestreSeleted = newVal;
        }
      },
    },
  },

  async created() {
    
  },

  computed: {
    anolectivo() {
      return ls.get("anolectivo");
    },

    

    totaisObject() {
      let totais = { multa: 0, desconto: 0, total: 0, totalGeral: 0 };
      this.desserts.forEach((element) => {
        if (element.isSelected) {
          totais.multa += element.valorMulta === "N/A" ? 0 : element.valorMulta;
          totais.desconto +=
            element.desconto === "N/A" ||
              element.desconto === null ||
              element.desconto === undefined
              ? 0
              : utilitarios.MoneyValueToInteger(element.desconto);
          totais.total +=
            element.preco === "N/A"
              ? 0
              : element.fkMes === 100
                ? element.preco * element.qtd
                : element.preco;
          totais.totalGeral += element.subtotal;
        }
      });
      return totais;
    },

    isAtLeastOneEmolumentoSelected() {
      let selectedCounter = 0;
      this.desserts.forEach((element) => {
        if (element.isSelected) {
          selectedCounter += 1;
        }
      });
      return selectedCounter > 0;
    },
  },

  mounted() {
    this.$on("carregarPagamentos", this.PesquisarStatusPagamento);
    this.$on("carregarPagamentoData", this.PesquisarStatusPagamentoData);
    this.$on("carregarPagamentoTrimestre",this.PesquisarStatusPagamentoTrimestre);
  },

  methods: {
    PesquisarStatusPagamentoData(data) {
      this.dataPagamentoSelected = data;
      this.PesquisarStatusPagamento();
    },

   precoSemIva(valorFinal, taxaIva = 14) {
    const precoBase = valorFinal / (1 + taxaIva / 100);
    return precoBase;
  },

    

    PesquisarStatusPagamentoTrimestre(trimestre) {
      this.trimestreSeleted = trimestre;
      this.PesquisarStatusPagamento();
    },

    async vericarBolseiro() {
      try {
        let bolseiros = await axios.get("/vericarStatusBolseiro/" + this.estudante.numero_matricula)
          .then((res) => res.data);
        if (bolseiros.length) {
          this.bolseiro = bolseiros[0];
        }
      } catch (error) {
        Swal.fire("Erro", "Erro ao verificar bolseiro!", "error"
        );
      }
    },

    async PesquisarStatusPagamento() {
 
      this.isLoading = true;
      try {
        let payload = {
          result: this.estudante,
          semestreId: this.trimestreSeleted.id,
          dataPagamento: this.dataPagamentoSelected,
        };

        this.desserts = await axios.post("/ObterItemsPorPagar", payload).then((res) => res.data);
 
      } catch (error) {        
        Swal.fire(
          "Informação",
          "Erro ao carregar os itens de pagamento",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    calcularPercentagem(parte, total) {
      return total - ((parte / 100) * total);
    },

    moneyFormat(produto) {
      try {
        this.isError = false;
        if (
          produto.desconto < 0 ||
          produto.desconto.trim() == "" ||
          isNaN(produto.desconto.trim())
        ) {
          produto.desconto = "0";
        }
        let subTotal =
          produto.preco +
          produto.valorMulta -
          this.utilitarios.MoneyValueToIntegerWithouKz(produto.desconto);
        if (subTotal < 0) {
          Swal.fire(
            "Informação",
            "O valor do desconto não pode ser maior do que o preço a pagar",
            "warning"
          );
          this.isError = true;
        }

        this.desserts[this.desserts.indexOf(produto)].desconto =
          this.utilitarios.IntegerToMoneyValueFatura(produto.desconto);
        this.desserts[this.desserts.indexOf(produto)].descontoInteiro =
          this.utilitarios.MoneyValueToIntegerWithouKz(produto.desconto);
        this.desserts[this.desserts.indexOf(produto)].subtotal = subTotal;
      } catch (error) {
        Swal.fire("Informação", "Erro ao fazer o desconto!", "error");
      }
    },

    async uncheckFunction(produto) {
      this.desserts[this.desserts.indexOf(produto)].desconto = "";
      if (produto.fkMes === 1000 && produto.isSelected === false) {
        let params = {
          item: produto.pkItemsVenda,
          emolumento: produto,
          estudante: this.estudante,
        };
        let deleted = await axios
          .post("/deletarItemUnchecked", params)
          .then((res) => res.data);
        if (deleted.affectedRows >= 1) {
          this.PesquisarStatusPagamento();
        }
      }
    },

    continuarPagamento() {
      let paramsVenda = {
        venda: this.desserts.filter(
          (i) => i.isSelected === true || i.isSelected === 1
        ),
        totais: this.totaisObject,
      };
      this.$emit("continuarPagamento", paramsVenda);
    }
  },
};
</script>

<style scoped>
.table-full {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.bg-gray100 {
  background-color: #f3f4f6;
}

.table_head {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.table_data {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.color-table-data {
  color: #141414;
}

.totaisContainer {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 10px;
}

.align-totais {
  margin-left: 15px;
}

.text-bold {
  font-weight: bold;
}

.totais-font-size {
  font-size: 17px;
}

.botoesAccaoContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 5px 15px;
}

.tpaCombox {
  width: 230px;
  margin: 10px 0;
}
</style>
